'use strict';

angular.module('utils').factory('OCUtil', function(OpencareConstants, CurrentUser, $q) {
  return {
    // Returns:
    // [{
    //   display: 'November 2015 (Current)',
    //   start: '2015-11-01',
    //   end: '2015-11-30'
    // }, ...]
    getMonthDropdownOptions: function(months) {
      var current = moment().endOf('month');
      var options = [];
      for (var i = 0; i < months; i++) {
        var option = {
          id: i,
          display: current.format('MMMM YYYY') + (i === 0 ? ' (Current)' : ''),
          end: current.format('YYYY-MM-DD'),
        };
        current.startOf('month');
        option.start = current.format('YYYY-MM-DD');
        options.push(option);
        current.subtract(1, 'day');
      }
      return options;
    },
    formatAppointmentTime: function(dateTime) {
      var startOfDay = moment(dateTime).startOf('day');
      var startTime = moment(dateTime).diff(startOfDay, 'minutes');
      var date = moment(dateTime).format(OpencareConstants.apiDateFormat);

      return {
        date: date,
        startTime: startTime,
      };
    },
    isNil: function(input) {
      return _.isNull(input) || _.isUndefined(input);
    },
    // https://github.com/GoogleChromeLabs/web-push-codelab
    urlB64ToUint8Array: function(base64String) {
      var padding = '='.repeat((4 - base64String.length % 4) % 4);
      var base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');
      var rawData = window.atob(base64);
      var outputArray = new Uint8Array(rawData.length);

      for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    },

    isPromoClinic: function(clinic) {
      return _.get(clinic, 'promoEnabled', false);
    },

    getModelFromURL: function(modelType) {
      return $q.when().then(function() {
        if (modelType === 'clinic') {
          return CurrentUser.getClinics();
        } else if (modelType === 'doctor') {
          return CurrentUser.getDoctors();
        }
      })
        .then(function(models) {
          if (!models) {
            return;
          }
          var modelId = window.location.hash.split('/')[2];
          var model = _.find(models, function(element) {
            return element.id == modelId;
          });

          return model ? model : models[0];
        });
    },

    /**
     * Sums the values of a specified property in an array of objects.
     *
     * @param {Object[]} arr - The array of objects to iterate over.
     * @param {string|function} propNameOrFn - The property name to sum or a function that returns the value to sum for each object.
     * @returns {number} The sum of the specified property values.
     */
    mapSum: (arr, propNameOrFn) => {
      const nums = arr.map((item) => {
        return typeof propNameOrFn === 'function' ? propNameOrFn(item) : item[propNameOrFn];
      });
      return nums.reduce((sum, num) => sum + (num ?? 0), 0);
    },
  };
});
